// start get all phone number


import { apiToken, phoneNumberByOrgIdURL, phoneNumberURL } from "../config"

export const getAllPhoneNumber = async () => {
    try {
        const response = await fetch(phoneNumberURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },

        })
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || 'Network response was not ok')
        }

        return res;
    } catch (e) {
        throw new Error(e.message || 'Failed')
    }
}

// end get all phone number

// Start get phone number with id
export const getPhoneNumberById = async (id) => {
    try {
        const phoneNumberWithIdUrl = `${phoneNumberURL}/${id}`
        const response = await fetch(phoneNumberWithIdUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok");
        }
        return res;
    } catch (e) {
        throw new Error(e.message || "Failed")
    }
}

// end get phone number with id

// start update phone number

export const updatePhoneNumber = async (id, data) => {
    try {
        const phoneNumberWithIdUrl = `${phoneNumberURL}/${id}`
        const response = await fetch(phoneNumberWithIdUrl, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        },
        );
        const res = await response.json();

        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok")
        }
        return res;
    } catch (e) {
        throw new Error(e.message || "Failed")
    }
}

//end update phone number

// start get phone number by orgId
export const getPhoneNumberByOrgId = async (orgId) => {
    try {
        const response = await fetch(`${phoneNumberByOrgIdURL}${orgId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        })
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Network response was not ok");
        }
        return res;
    } catch(e) {
        console.error("Error fetching phone numbers by orgId:", e);
        throw new Error(e.message || "Failed to fetch phone numbers by orgId");
    }
}

// end get phone number by orgId